<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'flowNo'" :required="isRequired('flowNo')" v-model="formData.flowNo"
                   :rules="getRules('flowNo')" label="编号" input-align="right" readonly/>
        <van-field v-f-show="'bxry'" v-model="formData.bxry" :required="isRequired('bxry')" name="flowName"
                   label="报销人" placeholder="报销人" input-align="right" :rules="getRules('bxry')">
          <template #input>
            <view-item @click.native="isShowPopup(deptUserTreeAll,'bxry')" :treeData="deptUserTreeAll.data"
                       :value="formData.bxry" placeholder="请选择报销人"/>
            <van-popup position="bottom" v-model="deptUserTreeAll.show">
              <van-nav-bar title="选择报销人" left-text="取消" right-text="确定"
                           @click-left="deptUserTreeAll.show = false" @click-right="handlePopupSubmit"/>
              <van-search v-model="deptUserTreeAll.filterText" @input="treeSearch($event, $refs.tree)" clearable
                          shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree ref="tree" @check-change="singleChoice($event,$refs.tree)" node-key="uuid" check-strictly
                           :data="deptUserTreeAll.data" :filter-node-method="filterNode" check-on-click-node
                           show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'sqr'" v-model="formData.sqr" :required="isRequired('sqr')" name="flowName" label="申请人"
                   placeholder="申请人" input-align="right" :rules="getRules('sqr')">
          <template #input>
            <view-item :value="formData.sqr" placeholder="请选择申请人"/>
          </template>
        </van-field>
        <van-field v-f-show="'ssbm'" input-align="right" name="ssbm" :required="isRequired('ssbm')"
                   :value="formData.ssbm" label="部门" :rules="getRules('ssbm')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssbm,'ssbm')" :value="formData.ssbm" placeholder="请选择部门"/>
            <van-popup v-model="ssbm.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssbm.show = false"
                           @click-right="popupSubmit('ssbm',{label:'label',value:'value'})"/>
              <van-search v-model="ssbm.filterText" @input="pickerSearch($event,ssbm,'label')" clearable shape="round"/>
              <van-picker ref="ssbm" value-key="label" :columns="ssbm.filteredData" @cancel="ssbm.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'hsgs'" input-align="right" name="hsgs" :value="formData.hsgs" :rules="getRules('hsgs')"
                   label="核算公司" placeholder="请选择核算公司">
          <template #input>
            <view-item @click.native="isShowPopup(hsgs,'hsgs')" :value="formData.hsgs" placeholder="请选择核算公司"/>
            <van-popup v-model="hsgs.show" position="bottom">
              <van-nav-bar title="选择核算公司" left-text="取消" right-text="确定" @click-left="hsgs.show = false"
                           @click-right="popupSubmit('hsgs',{label:'name',value:'id'})"/>
              <!-- <van-search v-model="hsgs.filterText" @input="pickerSearch($event,hsgs,'accountName')" clearable shape="round"/> -->
              <van-picker :duration="0" ref="hsgs" value-key="name" :columns="hsgs.filteredData"
                          @cancel="hsgs.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')"
                   :value="formData.ssxm" :rules="getRules('ssxm')" label="关联业务" placeholder="请选择项目/合同">
          <template #input>
            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm.split(',')[1]" placeholder="请选择项目/合同"/>
            <van-popup v-model="ssxm.show" position="bottom">
              <van-nav-bar title="选择项目/合同" left-text="取消" right-text="确定" @click-left="ssxm.show = false"
                           @click-right="businessSelectFinish('ssxm')"/>
              <van-row type="flex" align="center" class="p-r-20">
                <van-col :span="18">
                  <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'name', 'columnsLabel')" clearable
                              shape="round"/>
                </van-col>
                <van-col :span="6">
                  <van-button :loading="btnLoading" @click="selectMyProjectList('',true)" loading-text="加载中..."
                              type="primary" native-type="button" size="small">更多项目...
                  </van-button>
                </van-col>
              </van-row>
              <van-picker :duration="0" ref="ssxm" value-key="columnsLabel" :columns="ssxm.filteredData"
                          @cancel="ssxm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'ssxm'" v-model="deptcost" label="成本归属部门" input-align="right" readonly/>
        <van-field v-f-show="'bxsy'" v-model="formData.bxsy" :disabled="isDisabled('bxsy')"
                   :required="isRequired('bxsy')" name="bxsy" :rules="getRules('bxsy')" type="textarea" maxlength="200"
                   rows="3" autosize label="报销事由" show-word-limit placeholder="请输入报销事由" input-align="right"/>
        <van-field v-f-show="'skrfkbz'" v-model="formData.skrfkbz" :disabled="isDisabled('skrfkbz')"
                   :required="isRequired('skrfkbz')" :rules="getRules('skrfkbz')" name="skrfkbz" type="textarea"
                   maxlength="200" rows="3" autosize label="付款备注" show-word-limit
                   placeholder="填写付款备注时，避免使用 “福利、劳务费、工资、薪贴、奖金” 等相关表述。"
                   input-align="right"/>
       
     

        <van-field v-f-show="'startFlowDate'" v-model="formData.startFlowDate" :required="isRequired('startFlowDate')"
                   name="startFlowDate" label="报销日期"
                   placeholder="报销日期" input-align="right" :rules="getRules('startFlowDate')">
          <template #input>
            <view-item @click.native="isShowPopup(startFlowDate,'startFlowDate')" :value="formData.startFlowDate"
                       placeholder="请选择报销日期"/>
            <van-calendar v-model="startFlowDate.show" ref="startFlowDate" :min-date="startFlowDate.minDate"
                          :max-date="startFlowDate.maxDate" :show-confirm="false" title="选择报销日期"
                          @confirm="startFlowDateConfirm"></van-calendar>
          </template>
        </van-field>

        <!--        <van-field v-f-show="'fpfj'" :value.prop="formData.fpfj" input-align="right" name="fpfj" :required="isRequired('fpfj')" :rules="getRules('fpfj')" label="发票" placeholder="请上传文件">-->
        <!--          <template #input>-->
        <!--            <uploadFiles :disabled="isDisabled('fpfj')" :files="formData.fpfj" @success="uploadFpfjSuccess" module-type="flow"></uploadFiles>-->
        <!--          </template>-->
        <!--        </van-field>-->
        <van-field v-f-show="'fj'"  class="fileValueBox"  :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')"  
            :files="formData.fj" @success="uploadSuccess"
                         module-type="flow"   @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
         <van-field v-f-show="'papfj'"  class="fileValueBox"  :value.prop="formData.papfj" input-align="right" name="papfj" :required="isRequired('papfj')"
                   :rules="getRules('papfj')" label="纸质报销凭证" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('papfj')" :files="formData.papfj" @success="uploadPapfjSuccess"
                         module-type="flow" @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','papfj')"></uploadFiles>
          </template>
        </van-field>
        <van-field v-f-show="'skrbz'" v-model="formData.skrbz" :disabled="isDisabled('skrbz')"
                   :required="isRequired('skrbz')" :rules="getRules('skrbz')" name="skrbz" type="textarea"
                   maxlength="200" rows="3" autosize label="备注" show-word-limit
                   placeholder="请输入备注" input-align="right"/>
        <!--        <van-field v-f-show="'expense_type'" input-align="right" name="expense_type"-->
        <!--                   :required="isRequired('expense_type')" :rules="getRules('expense_type')"-->
        <!--                   :value="formData.expense_type" label="报销类别" placeholder="请选择报销类别">-->
        <!--          <template #input>-->
        <!--            <view-item @click.native="isShowPopup(expense_type,'expense_type')" :value="formData.expense_type"-->
        <!--                       placeholder="请选择报销类别"/>-->
        <!--            <van-popup v-model="expense_type.show" position="bottom">-->
        <!--              <van-nav-bar title="选择报销类别" left-text="取消" right-text="确定"-->
        <!--                           @click-left="expense_type.show = false" @click-right="popupSubmit('expense_type')"/>-->
        <!--              <van-search v-model="expense_type.filterText" @input="pickerSearch($event,expense_type)" clearable-->
        <!--                          shape="round"/>-->
        <!--              <van-picker ref="expense_type" :columns="expense_type.filteredData" @cancel="expense_type.show = false"/>-->
        <!--            </van-popup>-->
        <!--          </template>-->
        <!--        </van-field>-->
        <van-field v-f-show="'sfgzbx'" v-model="formData.sfgzbx" center input-align="right"
                   :required="isRequired('sfgzbx')" name="sfgzbx" :rules="getRules('sfgzbx')" label="是否挂账报销"
                   placeholder="是否挂账报销">~
          <template #label>
            <span>是否挂账报销</span>
            <van-icon name="question-o" @click="showGzbxHelpInfo" style="color: red;margin-left: 5px;"/>
          </template>
          <template #input>
            <view-item v-if="isDisabled('sfgzbx')" :value="formData.sfgzbx" placeholder="请选择是否挂账报销"/>
            <van-radio-group v-else @change="changeSfgzbx()" v-model="formData.sfgzbx" direction="horizontal">
              <van-radio name="否">否</van-radio>
              <van-radio name="是">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-notice-bar scrollable text="1、借款冲销：请选择要冲销的借款记录，并明确填写冲销金额。如果有现金需要退还给财务，请记得填写相应的现金退还金额。
2、供应商货款冲销：建议关联相应的付款审批流程。"/>
        <van-field v-f-show="'bxfs'" v-model="formData.bxfs" center input-align="right" :required="isRequired('bxfs')"
                   name="bxfs" :rules="getRules('bxfs')" label="报销方式" placeholder="请选择报销方式">~
          <template #input>
            <view-item v-if="isDisabled('bxfs')"
                       :value="formData.bxfs == '0' ? '正常报销' : (formData.bxfs == '1' ? '借款冲销' : '供应商货款冲销')"
                       placeholder="请选择申请人"/>
            <van-radio-group v-else @change="changeBxfs()" v-model="formData.bxfs" direction="horizontal">
              <van-radio class="m-r-20" name="0">正常报销</van-radio>
              <van-radio class="m-r-20" name="1">借款冲销</van-radio>
              <!--              <van-radio name="2">供应商货款冲销</van-radio>-->
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-f-show="'bxfs'" v-model="formData.debtMoney" :required="isRequired('debtMoney')"
                   label="累计借款欠款" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(formData.debtMoney)+' 元'"
                    v-if="formData.debtMoney && formData.debtMoney!=0"></span>
              <span v-else>无</span>
              <span class="p-l-20" v-if="formData.debtMoney && formData.debtMoney!=0"> 大写：</span>
              <span class="cor-F64646"
                    v-if="formData.debtMoney && formData.debtMoney != 0">{{ getChinese(formData.debtMoney) }}</span>
            </div>
          </template>
        </van-field>
      </van-cell-group>


      <van-row v-f-show="'fpfj'" class="m-t-20" type="flex" align="center">
        <van-col :span="12">
          <div class="font-32 font-weight-500 cor-00">发票信息</div>
        </van-col>
        <van-col :span="12">
          <van-button v-if="!isDisabled('fpfj')||formData.fpfj.length<=50" icon="add-o" round native-type="button" color="#FFDA3E"
                      text="上传并识别" @click="uploadInvoice"
                      class="width-100"/>
        </van-col>
      </van-row>
      <van-cell-group v-if="formData.fpfj.length === 0" class="text-center m-t-20 p-20">
        <img class="w-300 h-300 " :src="`${image_base_url}/null.png`"></img>
        <div class="font-24 cor-8B m-t-20">暂无发票信息~</div>
      </van-cell-group>
      <van-cell-group v-f-show="'fpfj'" v-for="(item,index) in formData.fpfj" :key="index" class="b-r-10 m-t-20">
        <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
          <van-row type="flex" align="center">
            <van-col :span="22">
              <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
              <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
            </van-col>
            <van-col v-if="isShowIcon('fpfj')" @click="removeItem(index,'fpfj')" :span="2">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </van-col>
          </van-row>
        </div>
        <div v-if="item.invoiceType == 3">
          <van-field v-model="item.invoiceTitle" label="发票抬头" input-align="right" readonly/>
          <van-field v-model="item.invoiceCode" label="发票号码" input-align="right" readonly/>
          <van-field v-model="item.invoiceDate" label="开票日期" input-align="right" readonly>
            <template #input>
              {{ item.invoiceDate }}
            </template>
          </van-field>
          <van-field v-model="item.ticketPrice" label="金额" input-align="right" readonly/>
          <van-field v-model="item.travelInformation" label="行程信息" input-align="right" readonly/>
          <van-field v-model="item.travelTime" label="乘车时间" input-align="right" readonly/>
          <van-field v-model="item.passenger" label="乘车人" input-align="right" readonly/>
        </div>
         <div v-else-if="item.invoiceType == 4">
          <van-field v-model="item.invoiceTitle" label="发票抬头" input-align="right" readonly/>
          <van-field v-model="item.invoiceCode" label="发票号码" input-align="right" readonly/>
          <van-field v-model="item.invoiceDate" label="开票日期" input-align="right" readonly>
            <template #input>
              {{ item.invoiceDate }}
            </template>
          </van-field>
      
          <van-field v-model="item.ticketPrice" label="机票金额" input-align="right" readonly/>
          <van-field v-model="item.fuelFee" label="燃油附加费" input-align="right" readonly/>
          <van-field v-model="item.civilFund" label="民航发展基金" input-align="right" readonly/>
          <van-field v-model="item.invoiceAmount" label="合计金额" input-align="right" readonly/>
          <!-- <van-field v-model="item.taxAmount" label="增值税税额" input-align="right" readonly/>
          <van-field v-model="item.otherFees" label="其他税费" input-align="right" readonly/> -->
          <van-field v-model="item.departureStation" label="出发城市" input-align="right" readonly/>
          <van-field v-model="item.arriveStation" label="到达城市" input-align="right" readonly/>
          <van-field v-model="item.passenger" label="乘机人" input-align="right" readonly/>
        </div>
        <div v-else>
          <van-field v-model="item.invoiceTitle" label="发票抬头" input-align="right" readonly/>
          <van-field v-model="item.invoiceCode" label="发票号码" input-align="right" readonly/>
          <van-field v-model="item.invoiceDate" label="开票日期" input-align="right" readonly>
            <template #input>
              {{ item.invoiceDate }}
            </template>
          </van-field>
          <van-field v-model="item.taxAmount" label="税额" input-align="right" readonly/>
          <van-field v-model="item.taxExcludedAmount" label="不含税金额" input-align="right" readonly/>
          <van-field v-model="item.invoiceAmount" label="价税合计金额" input-align="right" readonly/>
        </div>
       
           <van-field v-f-show="'fpfj'" :value.prop="item.file.filePath" input-align="right" name="fpfj" label="附件"
                   placeholder="请上传文件">
          <template #input>
            <!-- <van-image
                width="100"
                @click="fpfjClick(item)"
                height="100"
                :src="item.file.filePath"
            /> -->
             <div v-if="item.file.filePath" class="pdfFormBox"  @click="fpfjClick(item.file)">
              <PdfPreview :ref="'PdfPreview'+index" :pdf-url="item.file.filePath" />
          </div>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group class="m-t-20">
        <van-field center v-model="invoiceAmountTotal" label="发票金额合计" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(invoiceAmountTotal)+' 元'"
                    v-if="invoiceAmountTotal && invoiceAmountTotal!=0"></span>
              <span v-else>无</span>
              <div v-if="invoiceAmountTotal && invoiceAmountTotal!=0">
                <span class="p-l-20"> 大写：</span>
                <span class="cor-F64646">{{ getChinese(invoiceAmountTotal) }}</span>
              </div>
            </div>
          </template>
        </van-field>
        <van-field v-f-show="'elecTickets'" v-model="formData.elecTickets" :disabled="isDisabled('elecTickets')" type="digit"
                   :required="isRequired('elecTickets')" :rules="getRules('pjzselecTickets')" name="elecTickets" maxlength="50" autosize
                   label="电子票据张数" @blur="pjzsChange" placeholder="请输入电子票据张数" input-align="right"/>
      <van-field v-f-show="'papTickets'" @blur="pjzsChange" v-model="formData.papTickets" :disabled="isDisabled('papTickets')" type="digit"
                   :required="isRequired('papTickets')" :rules="getRules('papTickets')" name="papTickets" maxlength="50" autosize
                   label="纸质票据张数" placeholder="请输入纸质票据张数" input-align="right"/>
          <van-field v-f-show="'pjzs'" v-model="formData.pjzs" readonly type="digit"
                    :rules="getRules('pjzs')" name="pjzs" maxlength="50" autosize
                   label="票据张数" placeholder="请输入票据张数" input-align="right"/>
      </van-cell-group>
      <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">报销明细</div>
      <van-cell-group v-for="(item,index) in formData.bxmxb" :key="index" class="b-r-10 m-t-20">
        <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
          <van-row type="flex" align="center">
            <van-col :span="22">
              <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
              <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
            </van-col>
            <van-col v-if="isShowIcon('bxmxb')" @click="removeItem(index,'bxmxb')" :span="2">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </van-col>
          </van-row>
        </div>
        <van-field v-f-show="'bxlx'" v-model="item.bxlx" name="bxlx" :required="isRequired('bxlx')"
                   :rules="getRules('bxlx')" label="报销类型" placeholder="报销类型" input-align="right">
          <template #input>
            <view-item @click.native="popupShow(bxlx.show,index,'bxlx')" :value="item.bxlx"
                       placeholder="请选择报销类型"/>
            <van-popup position="bottom" v-model="bxlx.show[index]">
              <van-nav-bar title="选择报销类型" left-text="取消" right-text="确定"
                           @click-left="popupHidden(bxlx.show,index)" @click-right="bxlxPopupSubmit(item,index)"/>
              <van-search v-model="bxlx.filterText[index]" @input="treeSearch($event,$refs[`bxlxTree_${index}`])"
                          clearable shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree :ref="`bxlxTree_${index}`"
                           @check-change="singleChoice($event,$refs[`bxlxTree_${index}`],index)" node-key="id"
                           check-strictly :data="bxlx.data" :filter-node-method="filterNode" check-on-click-node
                           show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'bxje'" :disabled="isDisabled('bxje')" v-model="item.bxje" type="number" name="bxje"
                   :rules="getRules('bxje')" :required="isRequired('bxje')" :maxlength="10" placeholder="请输入报销金额"
                   label="报销金额" input-align="right" @change="formatToTwoDecimals(item, 'bxje')"></van-field>
        <van-field v-f-show="'fymx'" :disabled="isDisabled('fymx')" v-model="item.fymx" type="textarea" name="fymx"
                   :rules="getRules('fymx')" :required="isRequired('fymx')" maxlength="200" rows="3" autosize
                   label="费用明细" show-word-limit placeholder="请输入费用明细" input-align="right"/>
        <van-field v-f-show="'gskm'" :value="item.gskm" input-align="right" name="gskm" :rules="getRules('gskm')"
                   :required="isRequired('gskm')" label="归属科目" placeholder="请选择归属科目">
          <template #input>
            <view-item @click.native="popupShow(gskm.show,index,'gskm')" :value="item.gskm"
                       placeholder="请选择归属科目"/>
            <van-popup v-model="gskm.show[index]" position="bottom">
              <van-nav-bar title="选择归属科目" left-text="取消" right-text="确定"
                           @click-left="popupHidden(gskm.show,index)" @click-right="gskmSubmit(item,index)"/>
              <van-search v-model="gskm.filterText" @input="treeSearch($event,$refs[`gskmTree_${index}`])" clearable
                          shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree :ref="`gskmTree_${index}`"
                           @check-change="singleChoice($event,$refs[`gskmTree_${index}`],index)" node-key="id"
                           check-strictly :data="gskm.data" :filter-node-method="filterNode" check-on-click-node
                           show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'sfxyft'" v-model="item.sfxyft" center input-align="right"
                   :required="isRequired('sfxyft')" name="sfxyft" :rules="getRules('sfxyft')" label="是否分摊"
                   placeholder="请选择是否分摊">
          <template #input>
            <div v-if="isDisabled('sfxyft')">{{ item.sfxyft }}</div>
            <van-radio-group v-else v-model="item.sfxyft" direction="horizontal">
              <van-radio name="是" @click="handleFt(item)">是</van-radio>
              <van-radio name="否" @click="handleFt(item)">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>
      <van-row v-if="!isDisabled('bxmxb')">
        <van-col :span="12"></van-col>
        <van-col :span="12">
          <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加报销明细" @click="addBxItem"
                      class="width-100"/>
        </van-col>
      </van-row>
      <van-cell-group v-f-show="'bxzje'" class="m-t-20">
        <van-field v-f-show="'bxzje'" center v-model="formData.bxzje" :rules="getRules('bxzje')"
                   :required="isRequired('bxzje')" label="报销总金额" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(formData.bxzje)+' 元'" v-if="formData.bxzje && formData.bxzje!=0"></span>
              <span v-else>无</span>
              <div v-if="formData.bxzje && formData.bxzje!=0">
                <span class="p-l-20"> 大写：</span>
                <span class="cor-F64646">{{ getChinese(formData.bxzje) }}</span>
              </div>
            </div>
          </template>
        </van-field>
      </van-cell-group>
      <div v-if="formData.bxfs=='1'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">借款冲销</div>
        <van-field v-show="false" :value="formData.byjmxb[0]" :rules="getRules('byjmxb')"/>

        <van-cell-group v-for="(item,index) in formData.byjmxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `借款明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('byjmxb')" @click="removeItem(index,'byjmxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>

          <van-field v-f-show="'userName'" :required="isRequired('userName')" v-model="item.userName"
                     :rules="getRules('userName')" label="借款人" input-align="right" readonly/>
          <van-field v-f-show="'businessNo'" :required="isRequired('businessNo')" v-model="item.businessNo"
                     :rules="getRules('businessNo')" label="关联单号" input-align="right" readonly/>
          <van-field v-f-show="'debtTime'" :required="isRequired('debtTime')" v-model="item.debtTime"
                     :rules="getRules('debtTime')" label="借款时间" input-align="right" readonly>
            <template #input>
              {{ moment(item.debtTime).format('YYYY-MM-DD hh:mm:ss') }}
            </template>
          </van-field>
          <van-field v-f-show="'debtAmount'" :required="isRequired('debtAmount')" v-model="item.debtAmount"
                     :rules="getRules('debtAmount')" label="借款金额" input-align="right" readonly/>
          <van-field v-f-show="'repayAmount'" :required="isRequired('repayAmount')" v-model="item.repayAmount"
                     :rules="getRules('repayAmount')" label="已还款金额" input-align="right" readonly/>
          <van-field v-f-show="'currentRepayAmount'" :disabled="isDisabled('currentRepayAmount')"
                     v-model="item.currentRepayAmount" type="number" name="currentRepayAmount"
                     :rules="getRules('currentRepayAmount')" :required="isRequired('currentRepayAmount')"
                     :maxlength="10"
                     placeholder="请输入本次冲销金额" label="本次冲销金额" input-align="right"
                     @change="formatToTwoDecimals(item, 'currentRepayAmount')"></van-field>
          <!--          <van-field v-f-show="'payCash'" :disabled="isDisabled('payCash')" v-model="item.payCash" type="number"-->
          <!--                     name="payCash" :rules="getRules('payCash')" :required="isRequired('payCash')" :maxlength="10"-->
          <!--                     placeholder="请输入现金还款" label="现金还款" input-align="right"-->
          <!--                     @change="formatToTwoDecimals(item, 'payCash')"></van-field>-->

        </van-cell-group>
        <van-row v-if="!isDisabled('byjmxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加借款" @click="addImprest"
                        class="width-100"/>
          </van-col>
        </van-row>
        <van-cell-group v-f-show="'currentRepayAmountTotal'" class="m-t-20">
          <van-field v-f-show="'currentRepayAmountTotal'" center v-model="formData.currentRepayAmountTotal"
                     :rules="getRules('currentRepayAmountTotal')" :required="isRequired('currentRepayAmountTotal')"
                     label="本次冲销总金额" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.currentRepayAmountTotal)+' 元'"
                      v-if="formData.currentRepayAmountTotal && formData.currentRepayAmountTotal!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.currentRepayAmountTotal && formData.currentRepayAmountTotal!=0">
                  <span class="p-l-20"> 大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.currentRepayAmountTotal) }}</span>
                </div>
              </div>
            </template>
          </van-field>
          <van-field v-f-show="'payCashTotal'" center v-model="formData.payCashTotal" :rules="getRules('payCashTotal')"
                     :required="isRequired('payCashTotal')" label="本次现金还款总金额" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.payCashTotal)+' 元'"
                      v-if="formData.payCashTotal && formData.payCashTotal!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.payCashTotal && formData.payCashTotal!=0">
                  <span class="p-l-20"> 大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.payCashTotal) }}</span>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div v-if="formData.bxfs!='2'" class="flex row-between col-center m-t-20">
        <div class="font-32 font-weight-500 cor-00 ">收款人账户信息</div>
        <!-- <van-button type="primary" @click="account.show = true" native-type="button"></van-button> -->
        <van-button v-if="!isDisabled('skrhm')" icon="add-o" round native-type="button" color="#FFDA3E"
                    text="选择收款人账户"
                    @click="account.show = true" class="width-50"/>
      </div>
      <van-cell-group v-if="formData.bxfs!='2'" class="m-t-20">
        <van-field v-f-show="'skrhm'" v-model="formData.skrhm" :disabled="isDisabled('skrhm')"
                   :required="isRequired('skrhm')" name="skrhm" :rules="getRules('skrhm')" maxlength="50" autosize
                   label="收款人户名" placeholder="请输入收款人户名" input-align="right"/>
        <van-field v-f-show="'skrkhh'" v-model="formData.skrkhh" :disabled="isDisabled('skrkhh')"
                   :required="isRequired('skrkhh')" :rules="getRules('skrkhh')" name="skrkhh" maxlength="50" autosize
                   label="收款人开户行" placeholder="请输入收款人开户行" input-align="right"/>
        <van-field v-f-show="'skryhzh'" v-model="formData.skryhzh" :disabled="isDisabled('skryhzh')"
                   :required="isRequired('skryhzh')" :rules="getRules('skryhzh')" name="skryhzh" maxlength="50" autosize
                   label="收款人账号" placeholder="请输入收款人账号" input-align="right"/>
      </van-cell-group>
      <div v-f-show="'zcht'" v-if="isContract">
        <div class="font-32 font-weight-500 cor-00 m-t-26">关联合同</div>
        <van-cell-group class="m-t-20">
          <van-field input-align="right" name="zcht" :required="isRequired('zcht')" :rules="getRules('zcht')"
                     :value="formData.zcht" label="支出合同" placeholder="请选择支出合同">
            <template #input>
              <view-item @click.native="isShowPopup(zcht,'zcht')" :value="formData.zcht" placeholder="请选择支出合同"/>
              <van-popup v-model="zcht.show" position="bottom">
                <van-nav-bar title="支出合同" left-text="取消" right-text="确定" @click-left="zcht.show = false"
                             @click-right="popupSubmit('zcht',{label:'contractName',value:'contractId'})"/>
                <van-search v-model="zcht.filterText" @input="pickerSearch($event,zcht,'projectName')" clearable
                            shape="round"/>
                <van-picker ref="zcht" value-key="projectName" :columns="zcht.filteredData"
                            @cancel="zcht.show = false"/>
              </van-popup>
            </template>
          </van-field>
        </van-cell-group>
      </div>


      <van-field v-f-show="'zmlx'" input-align="right" name="zmlx" :required="isRequired('zmlx')"
                 :rules="getRules('zmlx')" label="账套类型" placeholder="请选择账套类型">
        <template #input>
          <view-item v-if="isDisabled('zmlx')" :showLabel="formData.zmlx"/>
          <van-checkbox-group v-else v-model="formData.zmlx" style="display: flex;" checked-color="rgb(255,218,62)">
            <van-checkbox name="管理账套" style="margin-right: 10px;">管理账套</van-checkbox>
            <van-checkbox name="核算账套">核算账套</van-checkbox>
          </van-checkbox-group>
        </template>
      </van-field>
      <van-cell-group class="m-t-20">
        <van-field v-f-show="'sfygz'" v-model="formData.sfygz" center input-align="right"
                   :required="isRequired('sfygz')" name="sfygz" :rules="getRules('sfygz')" label="是否有挂账"
                   placeholder="是否有挂账">
          <template #input>
            <view-item v-if="isDisabled('sfygz')" :value="formData.sfygz"/>
            <van-radio-group v-else v-model="formData.sfygz" direction="horizontal">
              <van-radio name="无">无</van-radio>
              <van-radio name="有">有</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-f-show="'gzje'" :disabled="isDisabled('gzje')" v-if="formData.sfygz==='有'" v-model="formData.gzje"
                   type="number" name="gzje" :rules="getRules('gzje')" :required="isRequired('gzje')" :maxlength="10"
                   placeholder="请输入挂账金额" label="挂账金额" input-align="right"
                   @change="formatToTwoDecimals(formData, 'gzje')"></van-field>
        <van-field v-f-show="'ckje'" :disabled="isDisabled('ckje')" v-model="formData.ckje" type="number" name="ckje"
                   :rules="getRules('ckje')" :required="isRequired('ckje')" :maxlength="10" placeholder="请输入出款金额"
                   label="出款金额" input-align="right" @change="formatToTwoDecimals(formData, 'ckje')"></van-field>
      </van-cell-group>

      <div v-f-show="'zffsmxb'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">财务出款</div>
        <van-cell-group v-for="(item,index) in formData.zffsmxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('zffsmxb')" @click="removeItem(index,'zffsmxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>
          <van-field v-f-show="'fkzh'" input-align="right" name="fkzh" :rules="getRules('fkzh')"
                     :required="isRequired('fkzh')" :value="item.fkzh" label="付款账户" placeholder="请选择付款账户">
            <template #input>
              <view-item @click.native="popupShow(fkzh.show,index,'fkzh')" :value="item.fkzh"
                         placeholder="请选择付款账户"/>
              <van-popup v-model="fkzh.show[index]" position="bottom">
                <van-nav-bar title="选择付款账户" left-text="取消" right-text="确定"
                             @click-left="popupHidden(fkzh.show,index)" @click-right="fkzhSubmit(item,index)"/>
                <van-search v-model="fkzh.filterText" @input="pickerSearch($event,fkzh,'name')" clearable
                            shape="round"/>
                <van-picker :ref="`fkzhPicker_${index}`" value-key="name" :columns="fkzh.filteredData"
                            @cancel="fkzh.show = false"/>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'zffs'" input-align="right" name="zffs" :rules="getRules('zffs')"
                     :required="isRequired('zffs')" :value="item.zffs" label="支付方式" placeholder="请选择支付方式">
            <template #input>
              <view-item @click.native="popupShow(zffs.show,index,'zffs')" :value="item.zffs"
                         placeholder="请选择支付方式"/>
              <van-popup v-model="zffs.show[index]" position="bottom">
                <van-nav-bar title="选择支付方式" left-text="取消" right-text="确定"
                             @click-left="popupHidden(zffs.show,index)" @click-right="zffsSubmit(item,index)"/>
                <van-search v-model="zffs.filterText" @input="pickerSearch($event,zffs,'name')" clearable
                            shape="round"/>
                <van-picker :ref="`zffsPicker_${index}`" value-key="name" :columns="zffs.filteredData"
                            @cancel="zffs.show = false"/>
              </van-popup>
            </template>
          </van-field>
          <van-cell-group class="m-t-20">
            <van-field v-f-show="'sfygz'" v-model="item.zjlx" center input-align="right"
                       :required="isRequired('sfygz')" name="zjlx" :rules="getRules('sfygz')" label="资金流向"
                       placeholder="请选择资金流向">
              <template #input>
                <view-item v-if="isDisabled('sfygz')" :value="item.zjlx"/>
                <van-radio-group v-else v-model="item.zjlx" direction="horizontal">
                  <van-radio name="收入">收入</van-radio>
                  <van-radio name="支出">支出</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </van-cell-group>
          <van-field v-f-show="'zfmxje'" :disabled="isDisabled('zfmxje')" v-model="item.zfmxje" type="number"
                     name="zfmxje" :rules="getRules('zfmxje')" :required="isRequired('zfmxje')" :maxlength="10"
                     placeholder="请输入支付金额" label="支付金额" input-align="right"
                     @input="formatToTwoDecimals(item, 'zfmxje')" @change="changeZffsmxb(item)"
          ></van-field>
        </van-cell-group>
        <van-row v-if="!isDisabled('zffsmxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加出款明细" @click="addFKItem"
                        class="width-100"/>
          </van-col>
        </van-row>
      </div>

      <div v-f-show="'relativeFlow'">
        <van-row type="flex" align="center" class="m-t-26 m-b-26">
          <van-col :span="12">
            <div class="font-32 font-weight-500 cor-00 ">关联流程</div>
          </van-col>
          <van-col :span="12">
            <van-button v-if="!isDisabled('relativeFlow')" icon="add-o" round native-type="button" color="#FFDA3E"
                        text="添加审批单" @click="addSpd"
                        class="width-100"/>
          </van-col>
        </van-row>
        <van-cell-group v-if="formData.relativeFlow.length === 0" class="text-center p-20">
          <img class="w-300 h-300 " :src="`${image_base_url}/null.png`"></img>
          <div class="font-24 cor-8B m-t-20">暂无关联流程，请点击“添加审批单”关联~</div>
        </van-cell-group>
        <van-cell-group v-else v-for="(item,index) in formData.relativeFlow" :key="index" class="b-r-10 m-t-20 p-20">
          <div class="flex col-center row-between">
            <!-- 标题 -->
            <div class="flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10">
              {{ item.title }}
            </div>
            <div v-f-show="'relativeFlow'" @click="removeItem(index,'relativeFlow')"
                 class="font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </div>
          </div>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">流程状态</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.businessStatusName }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">申请时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.startTime ? moment(item.startTime).format('YYYY-MM-DD') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">完成时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.endTime ? moment(item.endTime).format('YYYY-MM-DD') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">摘要</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.summary }}
              </div>
            </van-col>
          </van-row>
        </van-cell-group>
      </div>
    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <van-notice-bar scrollable
                    text="流程审批须知：请务必留意，审批流程的确定需依据成本归属部门进行。即，成本归属于哪个部门，则需由该部门的相关人员进行审批。"/>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class=""
               :actCurrentNode="processData.actCurrentNode || ''" :flowTraceList="flowTrace"
               :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"
              :formItemMap="formItemMap"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-35">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
    <relativeFlow :show="relativeFlow.show" @finish="relativeFlowFinish"
                  @close="relativeFlow.show = false"></relativeFlow>
    <account :show="account.show" @finish="accountFinish" @close="account.show = false"></account>
    <imprest :show="imprest.show" @finish="imprestFinish" @close="imprest.show = false"></imprest>
    <invoice :processInstanceId="processInstanceId" @close="invoiceClose" @success="invoiceSuccess"
             :show="invoice.show" ref="invoice"></invoice>
      <van-popup v-model="PdfPreviewShow" style="max-height:70%;overflow: auto; width: calc(100% - 20px);">
      <PdfPreview ref="PdfPreviewPop" :pdf-url="PdfPreviewPopFilePath"/>
      </van-popup>
  </div>
</template>
<script>
import PdfPreview from '@/components/PdfPreview/index.vue'; // 引入上述组件
import {
  getFormDataByInstanceId,
  getRelaveFormDataByInstanceId,
  getRemoteData,
  getSubjectTree,
  listContractAndProject,
  selectProjectDept
} from '@/api/flow'
import {getCurrentUserDept, getDeptUserTreeAll, getUser, getUserPayCompany} from '@/api/user.js'
import {getContractList} from '@/api/contract'
import {getAccountList, getCategoryTree} from '@/api/reimbursement.js'
import {queryFmAccount} from '@/api/account'
import moment from "moment";
import mixin from '@/mixin/flow'
import cache from "@/plugins/cache";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import relativeFlow from '@/components/flow/relativeFlow.vue'
import account from '@/views/tripReimbursement/components/account.vue'
import contract from './components/contract.vue'
import imprest from '@/components/flow/imprest.vue'
import invoice from '@/components/flow/invoice.vue'
import {Dialog, Toast} from 'vant';
import {formatToTwoDecimals} from "@/utils/ruoyi";

const bxItem = {
  // 报销金额
  bxje: "",
  // 报销类型
  bxlx: "",
  // 费用明细
  fymx: "",
  // 科目
  gskm: '',
}
const zfItem = {
  // 支付方式
  zffs: "",
  // 付款账户
  fkzh: "",
  // 支付金额
  zfmxje: ""
}
export default {
  mixins: [mixin,fileMixins],
  components: {invoice, uploadFiles, bottomBar, approver, flowTrace, relativeFlow, account, contract, Dialog, imprest,PdfPreview},
  watch: {
    // 'formData.ssxm': {
    //   handler(nvl) {
    //     // 获取支出合同
    //     this.getContractList(nvl)
    //   },
    //   deep: true
    // },
    'formData.fpfj': {
      handler(val) {
        this.calBillCount();
      },
      deep: true
    },

    'formData.byjmxb': {
      handler(val) {
        // 计算总金额
        this.formData.currentRepayAmountTotal = this.formData.byjmxb.reduce((pre, cur) => {
          return pre + Number(cur.currentRepayAmount)
        }, 0)
        this.formData.payCashTotal = this.formData.byjmxb.reduce((pre, cur) => {
          return pre + Number(cur.payCash)
        }, 0)
      },
      deep: true
    },
    'formData.bxmxb': {
      handler(val) {
        // 计算报销总金额
        this.formData.bxzje = this.formData.bxmxb.reduce((pre, cur) => {
          return pre + Number(cur.bxje)
        }, 0)

        val.findIndex(item => {
          if (!item.bxlx) return;
          if (item.bxlx.indexOf('固定资产') > -1 || item.bxlx.indexOf('成本类') > -1 || item.bxlx.indexOf('证件资质') > -1) {
            this.isContract = true
            if (!this.formData.ssxm) {
              this.$toast('请选择所属项目')
            }
          } else {
            this.isContract = false
          }
        })
      },
      deep: true
    },
    'formData.bxzje': {
      handler(val) {
        if (this.formData.sfygz === '无') { // 出款金额等于报销总金额
          this.formData.ckje = val
        } else {// 出款金额等于报销总金额 - 挂账金额
          this.formData.ckje = val - this.formData.gzje
        }
      },
    },
    'formData.gzje': {
      handler(val) {
        if (this.formData.sfygz === '无') { // 出款金额等于报销总金额
          this.formData.ckje = this.formData.bxzje
        } else {// 出款金额等于报销总金额 - 挂账金额
          this.formData.ckje = this.formData.bxzje - val
        }

      },
    },
    // 是否挂账
    // 'formData.sfygz': {
    //   handler(val) {
    //     this.formData.gzje = 0
    //   },
    // },
    // 出款金额
    'formData.ckje': {
      handler(val) {
        this.changeZffsmxb();
      },
    },
  },
  data() {
    const _this = this
    return {
      PdfPreviewShow: false,
      PdfPreviewPopFilePath: '',
      moment,
      // 成本部门
      deptcost: '',
      manageProject: 0, // 是否经营项目
      imprest: {
        show: false
      },
      btnLoading: false,
      account: {
        show: false,
      },
      contract: {
        show: false,
      },
      // 关联合同模块显示状态
      isContract: false,
      // 关联流程
      relativeFlow: {
        show: false
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      // 所属部门
      ssbm: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      startFlowDate: {
        show: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2030, 0, 1)
      },
      gskm: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 核算公司
      hsgs: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 发票识别
      invoice: {
        show: false
      },
      invoiceAmountTotal: 0,
      // 报销类别
      expense_type: {
        data: ["项目费用", "经营费用", "业务费", "和诚餐费", "其他",],
        show: false,
        filteredData: ["项目费用", "经营费用", "业务费", "和诚餐费", "其他"],
        filterText: '',
      },
      // 账目类型
      zmlx: {
        data: ["管理账套", "核算账套"],
        show: false,
        filteredData: ["管理账套", "核算账套"],
        filterText: '',
      },
      bxlx: {
        data: [],
        // 有多个popup时，需要一个数组来保存
        show: [],
        filterText: [],
      },
      formData: {
        // 申请日期
        startFlowDate: moment().format('YYYY-MM-DD'), // 当前日期 格式为yyyy-MM-dd,
        bxry: '',
        sqr: '',
        flowNo: '',
        ssbm: '',
        ssxm: '',
        bxsy: '',
        skrhm: '',
        skrkhh: '',
        skryhzh: '',
        skrfkbz: '报销款',
        skrbz: '',
        debtMoney: '',
        bxfs: '0',
        sfygz: '无',
        ckje: 0,
        gzje: '',
        expense_type: '',
        // 借款明细表
        byjmxb: [],
        // 本次冲销总金额
        currentRepayAmountTotal: 0,
        // 现金还款总金额
        payCashTotal: 0,
        // 报销明细 默认自带一条数据
        bxmxb: [{
          // 报销金额
          bxje: "",
          // 报销类型
          bxlx: "",
          // 费用明细
          fymx: "",
          // 科目
          gskm: '',
        }],
        // 出款明细
        zffsmxb: [{
          // 支付方式
          zffs: "",
          // 付款账户
          fkzh: "",
          // 支付金额
          zfmxje: "",
          // 资金流向
          zjlx: '支出',
        }],
        // 报销总金额
        bxzje: '',
        pjzs: 0,
        elecTickets:0,
        papTickets:'',
        fj: [],
        papfj: [],
        fpfj: [],
        zmlx: ['管理账套', '核算账套'],
        hsgs: "",
        relativeFlow: [],
        // 是否挂账报销
        sfgzbx: "否",

      },
      // 报销类型树
      tategoryTree: {
        data: []
      },
      // 账户树
      accountList: {
        data: []
      },
      // 关联合同
      zcht: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 付款账户
      fkzh: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      zffs: {
        data: [{name: '现金'}, {name: '对公'}, {name: '其他'}],
        show: [],
        filteredData: [{name: '现金'}, {name: '对公'}, {name: '其他'}],
        filterText: '',
      },
      // 自定义校验数据
      rules: {
        byjmxb: [
          {
            required: true,
            message: `借款明细不能为空`,
          }
        ],
        currentRepayAmount: [
          {
            validator: (value, rule) => {
              //console.log('val --------', value)
            }, message: '本次借款冲销总金额不能大于报销总金额'
          }
        ],
        currentRepayAmountTotal: [
          {
            validator: () => {
              return Number(_this.formData.currentRepayAmountTotal) <= Number(_this.formData.bxzje)
            }, message: '本次借款冲销总金额不能大于报销总金额'
          }
        ],

      },
      formItemMap: null, // 表单字段的Map
    }
  },
  created() {
    const _this = this
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          // form.data.papTickets=form.data.papTickets?form.data.papTickets:''
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          if (_this.formData.ssxm) {
            selectProjectDept({
              id: _this.formData.ssxm.split(',')[0],
              type: _this.formData.ssxm.split(',')[2] ? _this.formData.ssxm.split(',')[2] : 1
            }).then(ress => {
              _this.deptcost = ress.data.unitName
              _this.manageProject = ress.data.manageProject
            })
          }
            this.calBillCount()
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) {
      // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        // console.log(res, 'res.data.formData')
        // res.data.formData.papTickets=res.data.formData.papTickets?res.data.formData.papTickets:0
        Object.assign(this.formData, res.data.formData)
        if (this.formData.hsgs) {
          let belongUnit = this.formData.hsgs.split(',')[0]
          // 获取付款账户
          this.queryFmAccount({belongUnit})
        }
        // console.log(_this.formData.fpfj, 'this.formData')
        if (_this.formData.ssxm) {
          selectProjectDept({
            id: _this.formData.ssxm.split(',')[0],
            type: _this.formData.ssxm.split(',')[2] ? _this.formData.ssxm.split(',')[2] : 1
          }).then(ress => {
            _this.deptcost = ress.data.unitName
            _this.manageProject = ress.data.manageProject
          })
        }
        this.calBillCount()
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时候直接调用获取本人欠款
      this.getUserDebt()
      // 新增时调用
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 关联流程跳转时
      if (this.$route.query.isRelevanceFlow) {
        const params = {
          processInstanceId: this.$route.query.destProcessInstanceId,
          destGroupId: this.$route.query.groupId
        }
        getRelaveFormDataByInstanceId(params).then(res => {
          Object.assign(this.formData, res.data)
        })
      }
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.formData.sqr = currentUserInfo.userId
      this.formData.bxry = currentUserInfo.userId
      this.selectMyProjectList(currentUserInfo)
      this.getCurrentUserDept(currentUserInfo)
      // 查询用户的核算公司列表
      this.selectUserPayCompany(currentUserInfo)
      // 获取付款账户
      this.queryFmAccount()
    }

  },
  methods: {

          // 表单上的校验与特殊处理
    formValidator(){
        if(this.formData.fpfj.length>0||this.formData.elecTickets){
            if(this.formData.fpfj.length!=this.formData.elecTickets ){
              this.$toast("电子票据张数与上传的发票数据不对");
              return false;
            }
          }
          return true;
    },
    formatToTwoDecimals,
    handleFt(item) {
      if(item == '是'){
        if(this.manageProject!=1){
          this.$toast("仅关联「经营项目」的费用可进行固定资产分摊，当前关联业务不符合该规则，请退回申请人修改后重新提交");
          return
        }
      }
    },
    pjzsChange() {
      const elecTickets = parseFloat(this.formData.elecTickets) || 0;
      const papTickets = parseFloat(this.formData.papTickets) || 0;
      const totalTickets = elecTickets + papTickets;
      // 更新pjzs字段
      this.$set(this.formData, 'pjzs', totalTickets);
    },
    /**
     * @description:检验 仅关联「经营项目」的费用可进行固定资产分摊
     * @author: 孙小梅
     * @param {*}
     */
    validateApportion() {
      this.formData.bxmxb.forEach(item => {
        if (item.sfxyft && item.sfxyft == '是' && this.manageProject != 1) {
          this.$toast('仅关联「经营项目」的费用可进行固定资产分摊，当前关联业务不符合该规则，请退回申请人修改后重新提交');
          throw new Error('关联业务不符合规则');
        }
      })
    },
    // 进页面就调用
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      // 报销类型
      this.getCategoryTree()
      // 账户
      this.getAccountList()
      // 归属科目
      this.getSubject()
    },
    // 附件预览
    fpfjClick(item) {
     this.PdfPreviewShow=true
     this.PdfPreviewPopFilePath=item.filePath
     this.$nextTick(()=>{
      this.$refs['PdfPreviewPop'].initPdfjs(item.filePath)
      this.$refs['PdfPreviewPop'].resetPDF()
      this.$refs['PdfPreviewPop'].loadPDF(item.filePath)
    })
    },
    // 发票上传完成回调
    invoiceSuccess(data) {
      // console.log(data)
      this.formData.fpfj.push(data)
      let index=this.formData.fpfj.length-1
      this.$nextTick(()=>{
        // console.log(this.$refs['PdfPreview'+index])
         this.$refs['PdfPreview'+index][0].initPdfjs(data.filePath)
        this.$refs['PdfPreview'+index][0].resetPDF()
         this.$refs['PdfPreview'+index][0].loadPDF(data.filePath)
      
      })
      this.invoice.show = false
    },

    // 发票识别并上传
    uploadInvoice() {
      this.invoice.show = true
      this.$nextTick(()=>{
        this.$refs['invoice'].clearForm()
      })
    },
    calBillCount() {
      if (this.formData.fpfj) {
        let total = 0
        for (let i = 0; i < this.formData.fpfj.length; i++) {
          total = total + parseFloat(this.formData.fpfj[i].invoiceAmount&&this.formData.fpfj[i].invoiceAmount!=0 ? this.formData.fpfj[i].invoiceAmount : this.formData.fpfj[i].ticketPrice)
        }
        // this.formData.elecTickets=this.formData.fpfj.length
        this.$set(this.formData, 'elecTickets', this.formData.fpfj.length);
        this.pjzsChange()
        this.invoiceAmountTotal = parseFloat(parseFloat(total).toFixed(2))
      }
    },
    invoiceClose() {
      this.invoice.show = false;
    },
    // 借款选框
    imprestFinish(list) {
      console.log('借款列表', list)
      // 根据id对比list和formData.byjmxb，如果list中有formData.byjmxb没有的，添加到formData.byjmxb
      list.forEach(item => {
        if (!this.formData.byjmxb.find(ele => ele.id === item.id)) {
          this.formData.byjmxb.push(item)
        }
      })
      this.imprest.show = false;
    },
    // 显示合同选择框
    showContract() {
      if (!this.isDisabled('ssxm')) {
        this.contract.show = true
        this.$refs['contractSelect'].init()
      }
    },
    // 添加审批单
    addSpd() {
      this.relativeFlow.show = true
    },
    businessSelectFinish(field) {
      const item = this.$refs[field].getValues()[0]
      selectProjectDept({id: item.id, type: item.typeValue}).then(res => {
        this.deptcost = res.data.unitName
        this.manageProject = res.data.manageProject
      })
      this.$set(this.formData, 'ssxm', item.id + "," + item.name + "," + item.typeValue)
      this.$set(this[field], 'show', false)
      // this.$set(this.formData, field, item[props.value] + ',' + item[props.label])
    },

    // 收款人账户信息
    accountFinish(select) {
      this.formData.skrhm = select[0].accountName
      this.formData.skrkhh = select[0].accountBank
      this.formData.skryhzh = select[0].accountNo
      this.account.show = false
    },

    relativeFlowFinish(data) {
      // 循环遍历this.formData.relativeFlow，添加data中不重复的项目
      data.forEach(item => {
        if (!this.formData.relativeFlow.find(ele => ele.flowNo === item.flowNo)) {
          this.formData.relativeFlow.push(item)
        }
      })
      // this.formData.relativeFlow = data
      this.relativeFlow.show = false
    },
    startFlowDateConfirm(date) {
      this.formData.startFlowDate = moment(date).format('YYYY-MM-DD')
      this.startFlowDate.show = false
    },

    getReservationInfoAPI(params) {
      this.$loading.show()
      return new Promise((resolve, reject) => {
        this.getProcessInfo(params).then(res => {
          this.$loading.hide()
          Object.assign(thqueryFmAccountis.formData, res.data.formData)
          resolve(res)
        })
      })
    },
    queryFmAccount(params) {
      queryFmAccount(params).then(res => {
        this.fkzh.data = res.data
        this.fkzh.filteredData = res.data
      })
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.fj = fileList
    },
    uploadPapfjSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.papfj = fileList
    },
    uploadFpfjSuccess(fileList) {
      this.formData.fpfj = fileList
    },
    // 获取关联支出合同
    getContractList(val) {
      // 修改的时候也需要根据当前项目ID拿支出合同
      return new Promise(resolve => {
        getContractList({projectId: val.split(',')[0]}).then(res => {
          this.zcht.data = res.rows
          this.zcht.filteredData = res.rows
        })
      })
    },
    gskmSubmit(item, index) {
      let gskm = this.$refs[`gskmTree_${index}`][0].getCheckedNodes()[0].id;
      this.$set(item, 'gskm', gskm);
      // item.gskm = this.$refs[`gskmPicker_${index}`][0].getValues()[0].id + ',' + this.$refs[`gskmPicker_${index}`][0].getValues()[0].subjectPath;
      this.popupHidden(this.gskm.show, index)
    },
    fkzhSubmit(item, index) {
      let fkzh = this.$refs[`fkzhPicker_${index}`][0].getValues()[0].id + ',' + this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name;
      this.$set(item, 'fkzh', fkzh);
      if (this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name.includes('基本户') || this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name.includes('一般户')) {
        this.$set(item, 'zffs', '对公');
      } else {
        this.$set(item, 'zffs', '现金');
      }
      this.popupHidden(this.fkzh.show, index)
    },
    zffsSubmit(item, index) {
      let zffs = this.$refs[`zffsPicker_${index}`][0].getValues()[0].name;
      this.$set(item, 'zffs', zffs);
      this.popupHidden(this.zffs.show, index)
    },
    addBxItem() {
      this.formData.bxmxb.push(JSON.parse(JSON.stringify(bxItem)))
    },
    addFKItem() {
      this.formData.zffsmxb.push(JSON.parse(JSON.stringify(zfItem)));
      this.changeZffsmxb();
    },
    // 借款添加
    addImprest() {
      this.imprest.show = true;
    },
    removeItem(index, field) {
      if (this.formData[field].length === 1 && field !== 'relativeFlow') return this.$toast('请至少保留一项')
      this.$dialog.confirm({
        message: '确定删除该项吗？',
      }).then(() => {
        this.formData[field].splice(index, 1)
        if (field === 'zffsmxb') {
          this.changeZffsmxb()
        }
      })

    },
    // 归属科目
    getSubject() {
      getSubjectTree().then(res => {
        const data = this._getCategoryTree(res.data)
        this.gskm.data = data
        this.gskm.filteredData = data
      })
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssbm.data = res.data
          // 搜索过滤
          this.ssbm.filteredData = this.ssbm.data
          // 为所属部门赋默认值
          if (this.ssbm.filteredData.length > 0) {
            this.formData.ssbm = this.ssbm.filteredData[0].value + "," + this.ssbm.filteredData[0].label
          }
          resolve(res.data)
        })
      })
    },
    // 获取人员所属项目列表
    selectMyProjectList(user, more) {
      this.btnLoading = true
      const params = {
        userId: user.id || user.userId,
        more
      }
      return new Promise((resolve) => {
        listContractAndProject(params).then(res => {
          this.btnLoading = false
          this.ssxm.data = res.data
          this.ssxm.filteredData = res.data.map(item => ({
              ...item,
            columnsLabel: `${item.type}-${item.name}`
          }))
          resolve(res.data)
        })
      })
    },
    // 获取人员核算工资地址列表
    selectUserPayCompany(user) {
      return new Promise(resolve => {
        getUserPayCompany({userId: user.id || user.userId}).then(res => {
          this.hsgs.data = res.data
          this.hsgs.filteredData = res.data
          if (res.data.length > 0 && (!this.$route.query.processInstanceId)) {
            res.data.forEach(item => {
              if (item.selFlag == '1') {
                this.formData.hsgs = item.id + "," + item.name
              }
            })
          }
          resolve(res.data)
        })
      })
    },
    getUser(data) {
      getUser({userId: data.bxry}).then(res => {
        this.formData.bxryObj = res.data
        // 初始化获取用户所属项目
        this.selectMyProjectList(res.data)
        // 初始化获取用户部门
        this.getCurrentUserDept(res.data)
        // 获取用户核算公司列表
        this.selectUserPayCompany(res.data);
      })
    },
    bxlxPopupSubmit(item, index) {
      if (this.$refs[`bxlxTree_${index}`][0].getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一项', position: 'bottom'})
        return
      }
      item.bxlx = this.$refs[`bxlxTree_${index}`][0]?.getCheckedNodes()[0]?.id
      this.popupHidden(this.bxlx.show, index)
    },
    // 获取用户欠款
    getUserDebt(userId) {
      let url = '/payment/debt/selfDebt?userId='
      if (userId) {
        url = url + userId
      }
      getRemoteData(url, 'get', {}).then(response => {
        if (response.data) {
          this.formData.debtMoney = response.data.debt
          this.formData.bxfs = "0"
          // 根据用户欠款修改报销方式：正常报销、借款冲销
          // if (this.formData.debtMoney && this.formData.debtMoney != 0) {
          //   this.formData.bxfs = "1"
          // } else {
          //   this.formData.bxfs = "0"
          // }
        }
      });
    },

    // 报销人弹窗
    handlePopupSubmit() {
      if (this.$refs.tree.getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一人', position: 'bottom'})
        return
      }
      this.formData.hsgs = ''
      this.formData.bxry = this.$refs.tree.getCheckedNodes()[0].id
      // 切换人部门列表跟着换
      this.getCurrentUserDept(this.$refs.tree.getCheckedNodes()[0])
      // 切换人 项目列表跟着换
      this.selectMyProjectList(this.$refs.tree.getCheckedNodes()[0])
      // 切换人 重新请求核算公司列表
      this.selectUserPayCompany(this.$refs.tree.getCheckedNodes()[0])

      // 切换人 重新请求报销人欠款
      this.getUserDebt(this.formData.bxry)

      this.formData.ssbm = ''
      this.formData.ssxm = ''
      this.deptUserTreeAll.show = false
    },

    getAccountList() {
      return new Promise(resolve => {
        const params = {
          delFlag: 0
        }
        getAccountList(params).then(res => {
          this.accountList.data = res.data;
        })
      })
    },
    // 报销类型树
    getCategoryTree() {
      getCategoryTree().then(res => {
        const data = this._getCategoryTree(res.data)
        this.$set(this.bxlx, 'data', data)
      })
    },
    _getCategoryTree(treeList) {
      // 使用箭头函数来保持对 Vue 组件实例的 this 的引用
      const processTree = (originalItems) => {
        const newItems = []; // 创建一个新数组来存储处理过的节点
        originalItems.forEach(item => {
          const newItem = {...item}; // 创建一个新对象来避免修改原始数据
          newItem.disabled = newItem.children ? true : false;
          newItem.uuid = this.uuid(); // 确保正确访问 Vue 组件实例的方法
          if (newItem.children && newItem.children.length > 0) {
            newItem.children = processTree(newItem.children); // 递归调用并更新 children
          }
          newItems.push(newItem); // 将处理过的节点添加到新数组中
        });
        return newItems; // 返回新数组
      };
      return processTree(treeList); // 启动递归处理并返回新的树列表
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
    // 修改是否挂账报销
    changeSfgzbx() {
      if (this.formData.sfgzbx === "否") {
        // 不使用挂账报销时，收款人姓名、收款人开户行、收款人账号都必填，且显示
        this.changeItemShow("skrhm", "E");
        this.changeItemShow("skrkhh", "E");
        this.changeItemShow("skryhzh", "E");
        this.changeItemShow("bxfs", "E");

        this.changeItemRequire("skrhm", true);
        this.changeItemRequire("skrkhh", true);
        this.changeItemRequire("skryhzh", true);
        this.changeItemRequire("bxfs", true);

        this.formData.sfygz = '无';

      } else {
        // 使用挂账报销时，收款人开户行、收款人账号都非必填，且不显示
        this.changeItemShow("skrhm", "E");
        this.changeItemShow("skrkhh", "H");
        this.changeItemShow("skryhzh", "H");
        this.changeItemShow("bxfs", "H");

        this.changeItemRequire("skrhm", false);
        this.changeItemRequire("skrkhh", false);
        this.changeItemRequire("skryhzh", false);
        this.changeItemRequire("bxfs", false);

        this.formData.sfygz = '有';
      }
      // this.changeCkzjeByGzbx()
    },
    // 修改修改报销方式
    changeBxfs() {
      // console.log('修改修改报销方式', this.formData.bxfs)
      if (this.formData.bxfs === "1") {
        this.imprest.show = true
      }
      if (this.formData.bxfs === "2") {
        this.changeItemRequire("skrhm", false);
        this.changeItemRequire("skrkhh", false);
        this.changeItemRequire("skryhzh", false);
      } else {
        this.changeItemRequire("skrhm", true);
        this.changeItemRequire("skrkhh", true);
        this.changeItemRequire("skryhzh", true);
      }
    },
    // 挂账报销帮助提示
    showGzbxHelpInfo() {
      Dialog.alert({
        title: '挂账报销提示',
        message: '挂账报销为将使费用先行记入账务，等待后续通过专门的付款流程进行实际支付；',
        theme: 'round-button',
      }).then(() => {
        // on close
      });
    },
    // 修改出款明细
    changeZffsmxb(eItem) {
      let ckjeTotal = JSON.parse(JSON.stringify(this.formData.ckje))
      let zfjeTotal = 0;
      this.formData.zffsmxb.map(item => {
        item.zfmxje = Number(item.zfmxje)
        zfjeTotal = zfjeTotal + item.zfmxje;
      })
      // 计算需要补上的数额
      let cha = ckjeTotal - zfjeTotal;

      this.formData.zffsmxb.map(item => {
        if (eItem != item) {
          if (cha == 0) {
            return;
          }
          let itemResult = item.zfmxje + cha;
          if (itemResult > 0) {
            item.zfmxje = item.zfmxje + cha;
            cha = 0;
          } else {
            item.zfmxje = item.zfmxje + (cha - itemResult)
            cha = cha - (cha - itemResult)
          }
        }
      })

      if (cha < 0) {
        Toast.fail("支付金额大于出账金额，请检查")
      }
      this.changeCkzjeByGzbx()
    },
    // 如果是挂账报销 挂账报销金额等于出款总金额，出款金额为0
    changeCkzjeByGzbx() {
      if (this.formData.sfgzbx === "是") {
        this.formData.gzje = this.formData.bxzje
        this.formData.ckje = 0;
      }
    },
  }
}
</script>
<style
 lang="scss">
 .pdfFormBox {
  width: 50%;
  max-height: 300px;
  padding:10px;
  overflow: auto;
  touch-action: pan-y; /* 允许垂直滚动，阻止其他触摸动作干扰 */
  /* 移动端触摸优化 */
  -webkit-overflow-scrolling: touch;
}

.pdfFormBox iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
  box-shadow: 0 1px 6px rgba(0,0,0,0.12);
}
</style>
